require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-action-does-bic-hope-to-see-afbd-take-to-prevent.json") })
        }
      }, "path---en-us-update-what-action-does-bic-hope-to-see-afbd-take-to-prevent");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-action-does-bic-hope-to-see-afbd-take-to-prevent!./.cache/json/en-us-update-what-action-does-bic-hope-to-see-afbd-take-to-prevent.json
// module id = 823
// module chunks = 231608221292675